import { Dedupe as DedupeIntegration } from "@sentry/integrations";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import type { BrowserTracingOptions } from "@sentry/tracing/dist/browser/browsertracing";

export function InitSentry(routingInstrumentation: BrowserTracingOptions["routingInstrumentation"]) {
  Sentry.init({
    dsn:
      process.env.NODE_ENV !== "development"
        ? "https://ca7680d39d89446c8a0d545eb244861d@o463363.ingest.sentry.io/5468329"
        : "",
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation,
      }),
      new DedupeIntegration(),
    ],

    // While we have very little traffic and our total transactions do not even
    // come close to 50% capacity, let's keep every single call. As we grow/scale
    // we will clearly have to revisit this
    tracesSampleRate: 1.0,
    attachStacktrace: true,
    environment: process.env.REACT_APP_ENV,
  });
}
